import React, { Component } from "react";
import "./MyMapsItem.scss";
import * as drawingHelpers from "../../../helpers/drawingHelpers";
import Feature from "ol/Feature";
import VectorLayer from "ol/layer/Vector";
import { Vector as VectorSource } from "ol/source.js";
import { Stroke, Style, Fill, Circle as CircleStyle } from "ol/style";
import * as helpers from "../../../helpers/helpers";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faPalette } from "@fortawesome/free-solid-svg-icons/faPalette";
import { faPen } from "@fortawesome/free-solid-svg-icons/faPen";

class MyMapsItem extends Component {
  constructor(props) {
    super(props);

    this.vectorLayer = null;

    this.state = {
      label: props.info.label,
      checked: props.info.visible,
    };
    this.resizeObserver = null;
  }

  // LABEL INPUT
  onLabelTextChange = (evt) => {
    this.setState({ label: evt.target.value });
    this.props.onLabelChange(this.props.info.id, evt.target.value);
    this.adjustTextAreaHeight(evt); // Aktualizuj výšku počas zmeny
  };

  // DELETE BUTTON
  onItemDelete = (evt) => {
    this.props.onItemDelete(this.props.info.id);

    if (this.vectorLayer !== null) {
      window.map.removeLayer(this.vectorLayer);
      this.vectorLayer = null;
    }
  };

  // VISIBILITY CHECKBOX
  onItemCheckbox = (evt) => {
    this.setState({ checked: evt.target.checked });
    this.props.onItemCheckboxChange(this.props.info, evt.target.checked);
  };

  // THIS IS REQUIRED WHEN CHANGING LABEL FROM POPUP OR SHOW/HIDE ALL FROM PARENT
  componentWillReceiveProps(nextProps) {
    if (nextProps.info.label !== this.state.label)
      this.setState({ label: nextProps.info.label });
    if (nextProps.info.visible !== this.state.checked)
      this.setState({ checked: nextProps.info.visible });
  }

  componentDidMount() {
    if (this.textarea) {
      // Inicializácia ResizeObserver
      this.resizeObserver = new ResizeObserver(() => {
        if (this.textarea.scrollHeight > 0) {
          this.adjustTextAreaHeight({ target: this.textarea });
        }
      });

      // Pridanie pozorovateľa na textarea
      this.resizeObserver.observe(this.textarea);
    }
  }

  componentWillUnmount() {
    // Odstránenie ResizeObserver pri demontáži komponentu
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  adjustTextAreaHeight = (event) => {
    const target = event.target;
    target.style.height = "auto"; // Resetuje výšku pred meraním
    target.style.height = `${target.scrollHeight}px`; // Nastaví výšku podľa obsahu
  };
  
  onMenuItemClick = (action) => {
    switch (action) {
      case "sc-floating-menu-buffer":
        this.props.showDrawingOptionsPopup(
          drawingHelpers.getFeatureById(this.props.info.id),
          null,
          "buffer"
        );
        break;
      default:
        break;
    }
  };

  onSymbolizerClick = (evt) => {
    console.log("props", this.props);
    const drawType =
      this.props.info.drawType === "Text" ? "none" : "symbolizer";
    const feature = drawingHelpers.getFeatureById(this.props.info.id);
    this.props.showDrawingOptionsPopup(feature, null, drawType);
  };

  onMouseOver = (evt) => {
    if (drawingHelpers.getFeatureById(this.props.info.id) === null) return;

    // LAYER FOR HIGHLIGHTING
    if (this.vectorLayer === null) {
      var shadowStyle = new Style({
        stroke: new Stroke({
          color: [0, 0, 127, 0.3],
          width: 6,
        }),
        image: new CircleStyle({
          radius: 10,
          stroke: new Stroke({
            color: [0, 0, 127, 0.3],
            width: 6,
          }),
          fill: new Fill({
            color: [0, 0, 127, 0.3],
          }),
        }),
        zIndex: 100000,
      });

      var feature = new Feature({
        geometry: drawingHelpers
          .getFeatureById(this.props.info.id)
          .getGeometry(),
      });

      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [feature],
        }),
        zIndex: 100000,
        style: shadowStyle,
      });
      window.map.addLayer(this.vectorLayer);
    }
  };

  onMouseOut = (evt) => {
    window.map.removeLayer(this.vectorLayer);
    this.vectorLayer = null;
  };
  
  render() {
    return (
      <div
        className="sc-mymaps-item-container"
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
      >
        <div className="sc-mymaps-item-container-item">
          <input
            type="checkbox"
            style={{ verticalAlign: "middle" }}
            checked={this.state.checked}
            onChange={this.onItemCheckbox}
          />
          <div className={this.state.checked ? "" : "sc-disabled"}>
            <FontAwesomeIcon
              className="mymaps-palette-icon"
              icon={faPalette}
              onClick={this.onSymbolizerClick}
            />
            <textarea
              className="sc-mymaps-item-container-item-text-input"
              ref={(el) => (this.textarea = el)} // Nastavíme ref pre textarea
              defaultValue={this.state.label} // Použijeme defaultValue namiesto value
              onChange={(e) => {
                this.onLabelTextChange(e); // Zavolaj metódu na zmenu textu
                this.adjustTextAreaHeight(e); // Aktualizuj výšku
              }}
              title={this.state.label}
            />
            {/* <FontAwesomeIcon className="mymaps-pen-icon" icon={faPen} /> */}
          </div>
          <div className={this.state.checked ? "right" : "right sc-disabled"}>
            <FontAwesomeIcon
              className="mymaps-trash-icon"
              icon={faTrash}
              title="Zmazať kresbu"
              onClick={this.onItemDelete}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MyMapsItem;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("./images", false, /\.(png|jpe?g|svg)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}
